<template>
    <div class="gradPhoto">
        <div class="cont-box">
            <Title text="毕业照" />
            <div v-if="info.is_graduate_img == 1">
                <div v-if="info.is_check != 0" class="info">
                    <div class="item">
                        <span class="title">审核状态</span>
                        <span class="value">
                            <el-tag :type="info.is_check | isCheckStyle">
                                {{ info.is_check | isCheckFilter }}
                            </el-tag>
                        </span>
                    </div>
                    <div class="item" v-if="info.check_remark ? true : false">
                        <span class="title">审核备注</span>
                        <span class="value">{{info.check_remark}}</span>
                    </div>
                    <div class="item">
                        <span class="title">毕业照</span>
                        <span class="value">
                            <!-- <img :src="seeImageUrl" alt="" style="width: 500px;"> -->
                            <el-image
                                v-if="info.grad_img ? true : false"
                                :src="info.grad_img"
                                fit="contain"
                                :preview-src-list="[info.grad_img]"
                                style="height: 200px;width: 200px;"
                            ></el-image>    
                        </span>
                    </div>
                </div>
                <div v-if="info.is_check == 0 || info.is_check == 3" class="btn-box" >
                    <el-upload 
                        class="upload-demo" 
                        action="" 
                        :http-request="upLoadImg" 
                        :show-file-list="false">
                        <el-button type="primary">上传毕业照</el-button>
                    </el-upload>
                    <div class="tips">蓝底标准证件照，跟学信网上的学历照片一致</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {putObject} from '@/utils/upload';
import {isAssetTypeAnImage} from '@/utils/func';
import {adultStudentUserGradPhoto, adultStudentUpGradPhoto} from '@/api/basic';
export default {
    name: 'gradPhoto',
    filters: {
        // 审核状态
        isCheckFilter(v){
            let obj = {
                0: '待上传',
                1: '待审核',
                2: '已通过', 
                3: '未通过', 
            };
            return obj[v];
        },
        // 审核状态 样式
        isCheckStyle(v){
            let obj = {
                0: '', 
                1: '', 
                2: 'success', 
                3: 'danger', 
            };
            return obj[v];
        },
    },
    data(){
        return {
            // seeImageUrl: '',  //毕业照
            info: {},
        };
    },
    created(){
        this.getData();
    },
    methods: {
        // 上传照片
        upLoadImg(file){
            let type = file.file.name.split('.')[file.file.name.split('.').length - 1];

            let isImg = isAssetTypeAnImage(type);

            if (!isImg) {
                this.$message.error('文件类型不正确，请选择图片格式的文件');
                return;
            }

            putObject(file, async url => {
                if (url) {
                    // const str = url.split('.zip')[0];
                    const params = {
                        grad_img: url
                    };
                    let res = await adultStudentUpGradPhoto(params);
                    if (res.code == 200) {
                        this.$message.success('上传成功');
                        // this.seeImageUrl = url;
                        this.getData();
                    }
                }
            }, null, 'student', type );
        },
        // 获取毕业照
        getData(){
            adultStudentUserGradPhoto().then(res => {
                if(res.code == 200){
                    this.info = res.result || {};
                    // this.seeImageUrl = res.result.grad_img;
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.gradPhoto{
    padding: 20px;
    min-height: $contentH;
    padding-bottom: 0;
    .cont-box{
        min-height: inherit;
        background-color: #fff;
        padding: 20px;
        .info{
            .item{
                margin: 10px 0;
                display: flex;
                .title{
                    font-weight: 600;
                    width: 80px;
                    text-align: right;
                }
                .value{
                    width: calc(100% - 90px);
                    padding-left: 10px;
                }
            }
        }
        .btn-box{
            .tips{
                color: #fa9050;
                height: 30px;
                margin-top: 5px;
            }
        }
    }
}
</style>